import React, { Component } from 'react';
import { capitalize } from 'lodash';

import { Label } from '../../components';

export default class Field extends Component {
  static defaultProps = {
    element: 'input',
  };

  handleChange = (event) => {
    const { onChange, name } = this.props;
    onChange(name, event.target.value);
  };

  render() {
    const {
      errors,
      name,
      labelText,
      attributes,
      required,
      element: Element,
      onChange: _onChange,
      ...otherProps
    } = this.props;
    return (
      <div className={`${name}-field`}>
        <Label
          attr={name}
          text={labelText || capitalize(name)}
          errors={errors}
        />
        <Element
          type={name}
          id={name}
          value={attributes[name] || ''}
          onChange={this.handleChange}
          required={required}
          {...otherProps}
        />
      </div>
    );
  }
}
